import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPasswordHide = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Iconsax/Linear/eyeslash",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M14.5298 9.46984L9.46984 14.5298C8.79884 13.8588 8.42188 12.9488 8.42188 11.9998C8.42188 11.53 8.51442 11.0647 8.69423 10.6306C8.87404 10.1965 9.13759 9.80208 9.46984 9.46984C9.80208 9.13759 10.1965 8.87404 10.6306 8.69423C11.0647 8.51442 11.53 8.42188 11.9998 8.42188C12.9488 8.42188 13.8588 8.79884 14.5298 9.46984Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77M8.41984 19.53C9.55984 20.01 10.7698 20.27 11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39998C20.7798 8.87998 20.4198 8.38998 20.0498 7.92998",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group 27",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M15.51 12.7C15.3745 13.3976 15.0337 14.0387 14.5312 14.5412C14.0287 15.0437 13.3876 15.3845 12.69 15.52M9.47 14.53L2 22M22 2L14.53 9.47",
					stroke: "black",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			})
		]
	})
});
export default SvgPasswordHide;
